import { Coordinates } from 'reducers/geolocation/geolocationReducer.types'

export const UPDATE_COORDINATES_IN_STATE_ACTION =
  'UPDATE_COORDINATES_ACTION' as const

export const updateCoordinatesInStateAction = (coordinates: Coordinates) => ({
  type: UPDATE_COORDINATES_IN_STATE_ACTION,
  coordinates,
})
